import { defineMessages } from '../define';

/** Общие слова: кнопки, языки, ошибки по умолчанию. */
export const common = defineMessages({
  ru: {
    'common.save': 'Сохранить',
    'common.cancel': 'Отмена',
    'settings.language': 'Язык',
  },
  en: {
    'common.save': 'Save',
    'common.cancel': 'Cancel',
    'settings.language': 'Language',
  },
  be: {
    'common.save': 'Захаваць',
    'common.cancel': 'Адмена',
    'settings.language': 'Мова',
  },
});
